import React from 'react';
import NavbarComponent from '../pages/Navbar';
import Footer from '../Footer';
import EntertainmentEventsBanner from './EntertainmentEventsBanner';
import CommitmentSection from "../CommitmentSection";
import EntertainmentEventsInfo from './EntertainmentEventsInfo';



const EntertainmentEventsDetails = () => {
  return (
    <>
      <NavbarComponent />
     <EntertainmentEventsBanner/>
     <CommitmentSection />
     <EntertainmentEventsInfo/>
     
      <Footer />
    </>
  );
};

export default EntertainmentEventsDetails;
